export default function SearchIcon(){
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 53" width="100%" height="100%">
			<circle cx="23" cy="23" r="20" fill="none" stroke="inherit" strokeWidth="3"/>
			<line x1="37" y1="37" x2="50" y2="50" stroke="inherit" strokeWidth="3"/>
		</svg>


	)
}